import { useCallback, useContext, useEffect } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

import { Businesses } from 'lib/api';
import { CUSTOMERS_ACTIONS } from 'context/customers/customersReducer';
import { CustomerContext } from 'context/customers/customersContext';
import CustomersTableRow from './CustomersTableRow/CustomersTableRow';
import './CustomersTable.css';

const { SET_CUSTOMERS } = CUSTOMERS_ACTIONS;
const TableColumns = [{ label: 'BUSINESS ID' }, { label: 'BUSINESS NAME' }, { label: 'STATUS' }, { label: 'ACTIONS' }];

const CustomersTable = () => {
    const {
        state: { customers, reloadCustomers },
        dispatch
    } = useContext(CustomerContext);

    const fetchCustomers = useCallback(async () => {
        try {
            const { rows: customerList } = await Businesses.getCustomers();
            dispatch({ type: SET_CUSTOMERS, payload: customerList });
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);
    useEffect(() => {
        fetchCustomers();
    }, [fetchCustomers, reloadCustomers]);

    return (
        <Box className="table-container">
            <Box className="table-name">Customers</Box>
            <TableContainer component={Paper} sx={{ maxHeight: 1440 }}>
                <Table>
                    <TableHead>
                        <TableRow className="table-header-row">
                            {TableColumns.reduce((tableCells, currentCell, index) => {
                                return tableCells.concat(
                                    <TableCell
                                        key={index}
                                        className="table-header-cell"
                                        sx={{
                                            textAlign: customers.length === 0 ? 'center' : 'left'
                                        }}>
                                        {currentCell.label}
                                    </TableCell>
                                );
                            }, [])}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ height: customers?.length === 0 && '536px' }}>
                        {customers.map(business => (
                            <CustomersTableRow key={business.id_business} row={business} />
                        ))}
                        {customers.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={9} sx={{ textAlign: 'center' }}>
                                    <BusinessIcon className="no-data-icon" />
                                    <Typography paragraph className="no-data-text">
                                        There are no customers!
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default CustomersTable;
